import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

export default function FadeIn(props) {
  const [fadeIn, setFadeIn] = useState(props.disable || false);
  const domRef = useRef(null);

  useEffect(() => {
    // IntersectionObserver unavailable in old browsers
    if (!window.IntersectionObserver) {
      setFadeIn(true);
      return;
    }

    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setFadeIn(true);
        }
      });
    });

    if (domRef && domRef.current) {
      observer.observe(domRef.current);
    }
  }, []);

  return (
    <Fade fadeIn={fadeIn} ref={domRef}>
      {props.children}
    </Fade>
  );
}

const Fade = styled.div`
  opacity: 0;
  transform: translateY(3vh);
  visibility: hidden;
  transition:
    opacity 1200ms ease-out,
    transform 1200ms ease-out,
    visibility 1200ms ease-out;
  will-change: opacity, transform, visibility;
  width: 100%;
  ${({ fadeIn }) => {
    if (fadeIn)
      return `
        opacity: 1;
        transform: none;
        visibility: visible;
    `;
  }}
`;
